import { ReactNode } from 'react';

import {
    Align,
    Box,
    BoxContent,
    FlexBox,
    GapSize,
    Icon,
    IconName,
    IconSize,
    Text,
    TextLevels,
    TrilogyColor,
    TypographyBold,
} from '@bytel/trilogy-react';

type PromoHomeStickerProps = {
    text?: string | ReactNode;
};

export function PromoHomeSticker({ text }: Readonly<PromoHomeStickerProps>) {
    if (!text) {
        return null;
    }

    return (
        <Box
            shadowless
            highlighted={TrilogyColor.ACCENT}
            backgroundColor={TrilogyColor.ACCENT_FADE}
            radius='xs'
            padding='none'
            className='w-fit'
        >
            <BoxContent>
                <FlexBox align={Align.CENTER} gap={GapSize.ZERO}>
                    <Icon size={IconSize.SMALL} name={IconName.PROMO} color={TrilogyColor.ACCENT} />
                    <Text level={TextLevels.TWO} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                        {text}&ensp;
                    </Text>
                </FlexBox>
            </BoxContent>
        </Box>
    );
}
